import styled from "styled-components";

export const Container = styled.div`
  margin: 10px 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Title = styled.h3`
  font-family: aria;
  font-size: 20px;
  font-weight: 600;
  color: #333;
`;

export const Price = styled.span`
  font-family: aria;
  font-size: 20px;
  font-weight: 600;
  color: #333;
`;
